import L from "leaflet";

/**
 * leaflet.markercluster is a UMD plugin that looks for a global `L`. Under an ES-module
 * bundler there is none, so publish it here. Import this module BEFORE the plugin.
 */
(globalThis as unknown as { L: typeof L }).L = L;

export { L };
